module.exports = __webpack_public_path__ + "static/media/2026_before_omikuji.8e50bff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newyear/2026/2026_before_omikuji.mp4
// module id = BXBv
// module chunks = 1